var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer_wrap",style:({
    background: _vm.isTheme ? '#303846' : '#303846',
    height:_vm.isTheme  ? '80px':'60px'
  })},[_c('div',{staticClass:"footer_inner",style:({
      color: _vm.isTheme ? '#ffffff' : '#ffffff'
    })},[_vm._m(0)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n      AI智能体市场由 "),_c('a',{attrs:{"href":"https://www.rainbond.com/feature/app-market"}},[_vm._v("Rainstore")]),_vm._v(" 驱动\n         京ICP备15028663\n    ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../cache/node/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09801732","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../cache/node/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer/index.vue
// module id = null
// module chunks = 